import { getWomanThumbImageUrl } from "../../../../utils/imageUrl";
import { useTranslation } from "../../../../i18n/LanguageProvider";
import Title from "../Title/Title";
import WomanCard from "../WomanCard/WomanCard";

function RemarkableWomenSection({ women }) {
    const { t } = useTranslation();

    if (!women?.length) {
        return null;
    }

    return (
        <section className="home-remarkable" aria-labelledby="home-remarkable-title">
            <Title id="home-remarkable-title" text={t("home.remarkable")} />
            <div className="cards">
                {women.map((woman) => (
                    <WomanCard
                        key={woman.id}
                        id={woman.id}
                        name={woman.name}
                        surname={woman.surname}
                        domain={woman.category_name}
                        categoryColor={woman.category_color}
                        image={getWomanThumbImageUrl(woman.image)}
                    />
                ))}
            </div>
            <div className="home-remarkable__cta-wrap">
                <a href="#women-directory" className="home-remarkable__cta">
                    {t("home.discoverWomen")}
                </a>
            </div>
        </section>
    );
}

export default RemarkableWomenSection;
